/* BoundlessBay theme — small progressive enhancements. Everything works without JS. */
(function () {
  'use strict';

  /* Mobile menu drawer (details/summary) */
  document.querySelectorAll('[data-menu-drawer]').forEach(function (drawer) {
    var header = drawer.closest('.site-header');
    drawer.addEventListener('toggle', function () {
      if (header) {
        var rect = header.getBoundingClientRect();
        document.documentElement.style.setProperty('--drawer-top', rect.bottom + 'px');
      }
      document.documentElement.classList.toggle('drawer-open', drawer.open);
      var summary = drawer.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', drawer.open ? 'true' : 'false');
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.open) {
        drawer.open = false;
        drawer.querySelector('summary').focus();
      }
    });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { drawer.open = false; });
    });
  });

  /* Generic tabs (flagship modules, product gallery) */
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var activeText = root.querySelector('[data-active-text]');
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (activeText) activeText.textContent = tab.getAttribute('data-text') || '';
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') next = tabs[0];
        if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); select(next, true); }
      });
    });
  });

  /* Product gallery thumbnails */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var target = thumb.getAttribute('data-thumb');
        gallery.querySelectorAll('[data-slide]').forEach(function (s) { s.hidden = s.getAttribute('data-slide') !== target; });
        thumbs.forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
      });
    });
  });

  /* Variant picker: keeps the hidden variant id, price and URL in sync */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = form.querySelector('input[name="id"]');
    var button = form.querySelector('[data-add-button]');
    var buttonLabel = button ? button.querySelector('[data-add-label]') : null;
    var priceEls = document.querySelectorAll('[data-product-price]');
    function current() {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (el) {
        if (el.tagName === 'SELECT') { opts[+el.dataset.optionIndex] = el.value; }
        else if (el.checked) { opts[+el.dataset.optionIndex] = el.value; }
      });
      return variants.find(function (v) { return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; }); });
    }
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-index]')) return;
      var v = current();
      if (!v) {
        if (button) button.disabled = true;
        if (buttonLabel) buttonLabel.textContent = button.dataset.unavailable;
        return;
      }
      idInput.value = v.id;
      if (button) button.disabled = !v.available;
      if (buttonLabel) buttonLabel.textContent = v.available ? button.dataset.add : button.dataset.soldOut;
      priceEls.forEach(function (el) { el.textContent = v.price_formatted; });
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
  });

  /* Sticky mobile buy bar — appears once the main add-to-cart button scrolls out of view */
  var mobileBuy = document.querySelector('[data-mobile-buy]');
  var mainBuy = document.querySelector('[data-add-button]');
  if (mobileBuy && mainBuy) {
    var ticking = false;
    var update = function () {
      ticking = false;
      mobileBuy.classList.toggle('is-visible', mainBuy.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* Auto-submit selects (collection sort) */
  document.querySelectorAll('[data-autosubmit]').forEach(function (el) {
    el.addEventListener('change', function () { el.form.submit(); });
  });

  /* Cart quantity: submit the cart form on change */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () { input.form.submit(); });
  });

  /* Product recommendations (loaded via Shopify's Section Rendering API) */
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    var url = el.dataset.url;
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim().length) {
        el.innerHTML = fresh.innerHTML;
        el.closest('[data-recommendations-section]').hidden = false;
      }
    }).catch(function () {});
  });
})();
